export const API_URL = 'https://8nk00ptxie.execute-api.us-east-1.amazonaws.com/prod'

export const COGNITO = {
  domain:      'https://minecraft-portal-mjlong.auth.us-east-1.amazoncognito.com',
  clientId:    '3e3jf8dejvcc1vdgfbq51n2vnf',
  redirectUri: `${window.location.origin}/callback`,
  scopes:      'openid email profile',
}
